import { TRANSLATION_SEPARATOR } from '../constants';

declare const window: any;

export function getTranslation(key: string, placeholder: string | number = ''): string {
  const translated = window.df_settings.translations[key] || key;
  const internalPlaceholder = ['string', 'number'].includes(typeof placeholder)
    ? placeholder.toString()
    : '';
  return translated.replace(TRANSLATION_SEPARATOR, internalPlaceholder);
}

export const getTranslationByCount = (
  count: number,
  transZero: string,
  transOne: string,
  transPlural: string,
) => {
  if (count === 0) {
    return getTranslation(transZero);
  } else if (count === 1) {
    return getTranslation(transOne);
  }
  return getTranslation(transPlural);
};

export function getConfig(key: string, defaultValue?: string): string {
  const configValue = window && window.df_settings && window.df_settings[key];
  if (configValue !== undefined) {
    return configValue;
  }
  console.error('Missing configuration key: ', key);
  return defaultValue || key;
}
